import { apiProxyRequest } from "Api/apiProxyRequest";
import { DeploymentSettings } from "Reducers/environment/deployment";

export const getDeploymentSettingsRequest = ({ projectId, environmentId }) =>
  apiProxyRequest<DeploymentSettings>(
    `/projects/${projectId}/environments/${environmentId}/settings`,
    "GET"
  );
